export const cleanUpRouteParams = <T>(
  params: T
): { [key in keyof T]: string } => {
  return Object.entries(params as Record<string, any>)
    .filter(([key, value]) =>
      key === 'page' ? parseInt(value + '', 10) > 1 : !!value && value?.length
    )
    .reduce(
      (obj, [key, value]) => ({
        ...obj,
        [key]: value,
      }),
      {} as { [key in keyof T]: string }
    )
}
